<template>
    <div v-pml-block="isLoading" class="w_h_100" :key="uniqueKey">
        <PmlHeader :record="record" :deal="deal" :payments="payments" @refresh="setData"></PmlHeader>
        <div class="container" v-if="quotation">
            <div class="row">
                <div class="col-md-4 col-md-push-8">
                    <PmlCompany :company="company" :deal="deal"></PmlCompany>
                    <div class="hidden-xs hidden-sm">
                        <PmlInfo :record="record"></PmlInfo>
                    </div>
                </div>
                <div class="col-md-8 col-md-pull-4">
                    <div class="panel panel-default m-b-5">
                        <div class="panel-body">
                            <div class="alert alert_default p-10 p-b-0">
                                <div class="row">
                                    <div class="col-sm-6 m-b-10 t_sm_center">
                                        <p><strong>{{ $t('issue_date') }}: </strong> {{ record.issue_date_at | pmlDate('DD/MM/YYYY') }}</p>
                                    </div>
                                    <div class="col-sm-6 m-b-10 t_right t_sm_center" v-if="record.number">
                                        <h5 class="m-0">{{ $t('number') }} <label class="label label-inverse f_size_12">{{ record.number }}</label></h5>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group clearfix">
                                <div class="col-sm-6 col-sm-push-6 t_right">
                                    <p v-if="record.due_date_at" class="t_sm_center">
                                        <strong>{{ $t('due_date') }}: </strong>
                                        <span class="text-danger">{{ record.due_date_at | pmlDate('DD/MM/YYYY') }}</span>
                                    </p>
                                </div>
                                <div class="col-sm-6 col-sm-pull-6">
                                    <h4 class="m-0" v-if="deal.lead">{{ deal.lead.full_name }},</h4>
                                </div>
                            </div>
                            <div class="form-group clearfix" v-if="record.annotations">
                                <div class="col-md-12" v-html="notes"></div>
                            </div>
                            <PmlProducts :record="record" :currency="currency" :products="products"></PmlProducts>
                        </div>
                    </div>
                    <PmlDiscounts :record="record" :currency="currency" :discounts="discounts"></PmlDiscounts>
                    <PmlTaxes :record="record" :currency="currency" :taxes="taxes"></PmlTaxes>
                    <div class="panel panel-default">
                        <div class="p-10-20">
                            <div class="table-responsive">
                                <table class="table m-0 table_quote_show">
                                    <tbody>
                                    <tr>
                                        <td colspan="2" class="t_right t_uppercase"><h4 class="m-0 bold">{{ $t('total') }}</h4></td>
                                        <td class="t_right w_150">
                                            <h4 class="m-0 bold">
                                                {{ (record.total_products + record.total_discounts + record.total_taxes) * record.exchange_rate | pmlCurrency(currency.symbol) }}
                                            </h4>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="hidden-md hidden-lg">
                        <PmlInfo :record="record"></PmlInfo>
                    </div>
                    <PmlSuppliers v-for="item in suppliers" :key="item.id" :item="item"></PmlSuppliers>

                    <div class="panel panel-default m-b-5" v-if="payments.length > 0">
                        <div class="panel-body">
                            <PmlPaymentPackages :record="record" :currency="currency" :payments="payments"></PmlPaymentPackages>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PmlCompany from './Company.vue'
    import PmlInfo from './Info.vue'
    import PmlHeader from './Header.vue'
    import PmlProducts from './Products.vue'
    import PmlPaymentPackages from './PaymentPackages.vue'
    import PmlDiscounts from './Discounts.vue'
    import PmlTaxes from './Taxes.vue'
    import PmlSuppliers from './Suppliers.vue'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { get } from 'services/my-quotation'
    import Zendesk from '@/assets/vendor/zendesk'

    export default {
        name: 'MyQuotation',
        components: { PmlCompany, PmlInfo, PmlHeader, PmlProducts, PmlPaymentPackages, PmlDiscounts, PmlTaxes, PmlSuppliers },
        data () {
            return {
                uniqueKey: Date.now(),
                quotation: {},
                isLoading: false
            }
        },
        watch: {
            $route: {
                handler () {
                    this.reloadComponent()
                    this.loadData()
                },
                immediate: true
            }
        },
        computed: {
            code () {
                return this.$route.params.code
            },
            record () {
                return this.quotation.quotation || {}
            },
            deal () {
                return this.quotation.deal || {}
            },
            products () {
                return this.quotation.products || []
            },
            discounts () {
                return this.quotation.discounts || []
            },
            taxes () {
                return this.quotation.taxes || []
            },
            suppliers () {
                return this.quotation.suppliers || []
            },
            company () {
                return this.quotation.company || {}
            },
            currency () {
                return this.quotation.currency || {}
            },
            payments () {
                return this.quotation.payments || {}
            },
            notes () {
                return this.$options.filters.pmlNl2br(this.record.annotations) || ''
            }
        },
        beforeCreate () {
            Zendesk.hide()
        },
        beforeDestroy () {
            Zendesk.show()
        },
        mounted () {
            this.loadData()
        },
        methods: {
            reloadComponent () {
                this.uniqueKey = Date.now()
            },
            setData (info) {
                this.quotation = info
            },
            loadData () {
                this.isLoading = true
                get(this.code)
                    .then(response => {
                        this.quotation = response.data
                        this.$i18n.locale = this.record.language
                    })
                    .catch(() => {
                        Notify.error(trans('_notifications.error'))
                    })
                    .then(() => { this.isLoading = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/my-quotation/components/Main.vue